import * as pollutionFactors from './pollutionFactors';
import * as waterLevel from './waterLevel';
import * as stationType from './stationType';
import * as mapUtils from './mapUtils';
import colorUtils from './colorUtils';
import * as crypto from './crypto';
import download from './download';
import * as svg from './svg';

const utils = {
  mapUtils,
  pollutionFactors,
  waterLevel,
  stationType,
  colorUtils,
  crypto,
  download,
  svg,
};

export default utils;
